// This store is used to save branding information
import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type State = {
	rsLogoUrl?: string | null;
	sfLogoUrl?: string | null;
};

type Actions = {
	setRsLogoUrl: (logoUrl?: string | null) => void;
	setSfLogoUrl: (logoUrl?: string | null) => void;
};

export type BrandingStore = State & Actions;

const initialState: State = {
	rsLogoUrl: null,
	sfLogoUrl: null,
};

export const createBrandingSlice: StateCreator<BrandingStore> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setRsLogoUrl(rsLogoUrl) {
			set(() => ({
				rsLogoUrl,
			}));
		},
		setSfLogoUrl(sfLogoUrl) {
			set(() => ({
				sfLogoUrl,
			}));
		},
	};
};
